import React, { useState } from 'react'
import { TextField, IconButton } from '@material-ui/core';
import { CloseOutlined } from '@material-ui/icons';
import { DateRangePicker as _DateRangePicker } from 'materialui-daterange-picker'
import moment from 'moment';
import "./DateRangePicker.scss"


export default function DateRangePicker({onChange, startDate, endDate}) {

  const [open, setOpen] = useState(false);

  const toggle = () => setOpen(!open);

  const clearInput = () => {
    onChange({startDate: null, endDate: null})
    setOpen(false);
  }

  const openOnClick = e => {
    if (typeof e.target.className === 'string' && !!e.target.className.match(/MuiInput-input/gi)) {
      setOpen(true);
    }
  }

  const dateValue = startDate && endDate ? `${moment(startDate).format("DD MMM YYYY")} – ${moment(endDate).format("DD MMM YYYY")}` : `Select dates...`

  return (
    <div style={{position: 'relative'}}>
      <TextField
        onClick={openOnClick}
        id="date"
        label="Spend date"
        type="text"
        // size="small"
        value={dateValue}
        InputProps={{
          style: { color: (startDate && endDate) ? 'black' : '#999' },
          readOnly: true,
          endAdornment:
            <IconButton onClick={clearInput} style={{padding: '3px'}}><CloseOutlined style={{fontSize:'16px'}} /></IconButton>  
        }}
        InputLabelProps={{ shrink: true }}
        fullWidth
      />
      <div className='date-range-picker'>
        <_DateRangePicker
          open={open}
          toggle={toggle}
          onChange={onChange}
        />
      </div>
    </div>
  )
}
